React = require 'react'
React.initializeTouchEvents true

require './routes'



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/init.cjsx
 **/